import React, { useState, useEffect } from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

const AccordionComponent = ({
    dataTables,
    dataTableIsLoading,
    handleFetchTableNodes,
    handleFetchTableNodeForVariables,
    selectedTables,
    variablesByTable
}) => {
   // Local state for immediate UI feedback
    const [localSelections, setLocalSelections] = useState({
        tables: new Set(),
        variables: new Set()
    });
    // Local state for tracking selected variables
    // const [selectedVariables, setSelectedVariables] = useState(new Set());

    const handleTableSelection = async (table) => {
        const newTables = new Set(localSelections.tables);
        const newVariables = new Set(localSelections.variables);

        if (newTables.has(table)) {
            newTables.delete(table);
            // Remove all variables for this table
            dataTables[table].forEach(v => newVariables.delete(`${table}-${v}`));
        } else {
            newTables.add(table);
            // Add all variables for this table
            dataTables[table].forEach(v => newVariables.add(`${table}-${v}`));
        }

        // Immediate UI update
        setLocalSelections({
            tables: newTables,
            variables: newVariables
        });

        // Update parent state
        await handleFetchTableNodes(table);
    };

    // Handle selecting/deselecting variables
    const handleVariableSelection = async (table, variable) => {
        const newVariables = new Set(localSelections.variables);
        const key = `${table}-${variable}`;

        if (newVariables.has(key)) {
            newVariables.delete(key);
        } else {
            newVariables.add(key);
        }

        // Immediate UI update
        setLocalSelections(prev => ({
            ...prev,
            variables: newVariables
        }));

        // Update parent state
        await handleFetchTableNodeForVariables(table, variable);
    };

    // Sync checkboxes with state
    useEffect(() => {
        setLocalSelections(prev => ({
            tables: new Set(selectedTables),
            variables: new Set(
                Object.entries(variablesByTable)
                    .filter(([table]) => selectedTables.includes(table))
                    .flatMap(([table, vars]) => vars.map(v => `${table}-${v}`))
            )
        }));
    }, [selectedTables, variablesByTable]);

    const isVariableSelected = (table, variable) => {
        return localSelections.variables.has(`${table}-${variable}`);
    };

    return (
        <Accordion allowZeroExpanded>
            <ul className="column">
                {Object.keys(dataTables).length > 0 && Object.keys(dataTables).map((table, index) => (
                    <AccordionItem key={index}>
                        <li style={{ fontWeight: "bold" }} className='__accodbefor'>
                            <AccordionItemButton>
                                <div className='__congflex'>
                                    <input
                                        type="checkbox"
                                        value={table}
                                        id={table}
                                        onChange={() => handleTableSelection(table)}
                                        checked={selectedTables.includes(table)}
                                        style={{
                                            display: "inline-block",
                                            marginRight: "5px",
                                            cursor: "pointer"
                                        }} />
                                    <label className='__congflpt' htmlFor={table} style={{ cursor: "pointer" }}>{table}</label>
                                </div>
                            </AccordionItemButton>
                            <AccordionItemPanel>
                                <ul style={{ fontWeight: "normal", fontSize: "12px" }} className="truncate">
                                    {dataTables[table].length > 0 && dataTables[table].map(variable => (
                                        <li className='__dislid' key={variable}>
                                            <div className='__congflex'>
                                                <input
                                                    type="checkbox"
                                                    value={variable}
                                                    id={variable}
                                                    onChange={() => handleVariableSelection(table, variable)}
                                                    checked={isVariableSelected(table, variable)}
                                                    style={{
                                                        display: "inline-block",
                                                        marginRight: "3px",
                                                        width: "10px",
                                                        height: "10px",
                                                        cursor: "pointer"
                                                    }} />
                                                <label className='__congflp' htmlFor={variable} style={{ fontWeight: "normal", cursor: "pointer" }}>{variable}</label>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </AccordionItemPanel>
                        </li>
                    </AccordionItem>
                ))}
                {Object.keys(dataTables).length === 0 && dataTableIsLoading && (
                    <img src="/assets/img/slice-and-dice-loader.svg" alt="" />
                )}
            </ul>
        </Accordion>
    );
};

export default AccordionComponent;